import { AtividadeTipo } from '../../../@types';
import makeForm from '../../../components/Form';
import Yup from '../../../utils/yup';
import { AtividadeFormValues } from '../types';

export const validationSchema = Yup.object().shape({
  descricao: Yup.string().required(),
  cor: Yup.string(),
  corFonte: Yup.string(),
  abreviatura: Yup.string().required(),
  tipo: Yup.string().required(),
  clienteAgrogestao: Yup.boolean().nullable(),
  perene: Yup.boolean().nullable(),
});

type TiposType = {
  id: number;
  value: AtividadeTipo;
  label: string;
}[];

export const tiposFilter: TiposType = [
  { id: 1, value: 'agricola', label: 'Agrícola' },
  { id: 2, value: 'permanente', label: 'Permanente' },
  { id: 3, value: 'leiteira', label: 'Leiteira' },
  { id: 4, value: 'corte_pecuaria', label: 'Pecuária de Corte' },
];

export const defaultValues: AtividadeFormValues = {
  descricao: '',
  cor: '',
  corFonte: '',
  tipo: tiposFilter[0].value,
  abreviatura: '',
  clienteAgrogestao: false,
};

export const AtividadeForm = makeForm<AtividadeFormValues>();
